import { render, staticRenderFns } from "./newStudent.vue?vue&type=template&id=70bfdd03&"
import script from "./newStudent.vue?vue&type=script&lang=js&"
export * from "./newStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports